// import node module libraries
import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import { Row, Col } from 'react-bootstrap';
import axios from 'axios';

// Import authentication components
import useAuthHeader from 'react-auth-kit/hooks/useAuthHeader';

// Import Loading Animation
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

// Import translation
import { useTranslation } from 'react-i18next';

// import sub components
import FlowCard from './FlowCard';

// import data files
import { AllConnectorsData } from 'data/slider/AllConnectorsData';

const FlowSlider = ({ standard, premium, category }) => {
	const settings = {
		infinite: true,
		slidesToShow: 3,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					initialSlide: 2
				}
			},
			{
				breakpoint: 540,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	};

	const { t } = useTranslation();
	const [FlowList, setFlowList] = useState([]);
	const [isLoading, setIsLoading] = useState(true);

	const authHeader = useAuthHeader();
	// fetch data from api
	const options = {
		params: {

		},
		headers: {
			Authorization: authHeader,
			Accept: 'application/json'
		}
	};

	const getData = async () => {
		setIsLoading(true);

		// Dynamische URL basierend auf der Umgebung
		const baseURL = process.env.REACT_APP_ENV === 'development'
			? `http://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`
			: `https://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`;

		await axios.get(`${baseURL}/public/marketplaceentries?key=flow`, options)
			.then(response => {
				const responseData = response.data.data; // Extract the data from the response
				setFlowList(
					responseData
						? responseData.map(item => ({
							id: item.id,
							...item.marketplace_value
						}))
						: []
				); // Map the data to match the expected keys
				setIsLoading(false);
			})
			.catch((error) => {
				setIsLoading(false);
			});
	}

	useEffect(() => {
		getData();
	}, []);

	return (
		<Fragment>
			{isLoading || FlowList && FlowList.length == 0 ? (
				<Row className="mb-5">
					<Col xs={3} className="text-center">
						<Skeleton className="rounded" count={1} height={450} />
					</Col>
					<Col xs={3} className="text-center">
						<Skeleton className="rounded" count={1} height={450} />
					</Col>
					<Col xs={3} className="text-center">
						<Skeleton className="rounded" count={1} height={450} />
					</Col>
					<Col xs={3} className="text-center">
						<Skeleton className="rounded" count={1} height={450} />
					</Col>
				</Row>
			) : (
				<Slider {...settings} className="pb-sm-5 mb-5 slick-slider-wrapper">
					{FlowList.map((item, index) => (
						<div className="item px-md-1" key={item.id} style={{ height: '100%' }}>
							<FlowCard key={index} item={item} extraclass="mx-2 h-100 d-flex flex-column" showprogressbar={true} />
						</div>
					))}
				</Slider>
			)}			
		</Fragment>
	);
};

// Specifies the default values for props
FlowSlider.defaultProps = {
	standard: false,
	premium: false,
	category: null
};

// Typechecking With PropTypes
FlowSlider.propTypes = {
	standard: PropTypes.bool,
	premium: PropTypes.bool,
	category: PropTypes.string
};

export default FlowSlider;
